/**
 * Modulstatus in der Shell (Konzept Kap. 08 §1.3, ADR-008 Nachtrag 22.10.2026).
 *
 * `inaktiv` = installiert, im Menü sichtbar, aber nicht klickbar · `beta` = produktiv im Einsatz,
 * aber im Test (Kennzeichnung BETA) · `produktiv` = live (keine Kennzeichnung). Den Status legt
 * der Entwickler in `module.yaml` fest. Die API bildet alte Phasen schon ab; die Shell tut es noch
 * einmal, damit auch ein älterer API-Stand richtig angezeigt wird (gleiche Tabelle wie
 * `apps/api/src/core/modul-status.ts`).
 *
 * Komfort, kein Schutz: „inaktiv“ sperrt nur das Öffnen in der Shell. Rechte prüft die API.
 * Reine Funktionen ohne DOM, damit sie testbar sind.
 */
import type { ModulStatus } from '@one/module-sdk';

const STATUS: Record<string, ModulStatus> = {
  inaktiv: 'inaktiv',
  beta: 'beta',
  produktiv: 'produktiv',
  plan: 'inaktiv',
  bau: 'beta',
  pilot: 'beta',
  live: 'produktiv',
  auslauf: 'produktiv',
};

/** Der Status eines Eintrags; unbekannt oder fehlend → undefined (zählt wie produktiv). */
export function modulStatus(roh: unknown): ModulStatus | undefined {
  return typeof roh === 'string' && Object.prototype.hasOwnProperty.call(STATUS, roh)
    ? STATUS[roh]
    : undefined;
}

/** Was die Kennzeichnung zeigt: BETA oder INAKTIV; produktiv bleibt ohne Badge. */
export function statusText(roh: unknown): string | null {
  const status = modulStatus(roh);
  if (!status || status === 'produktiv') return null;
  return status === 'beta' ? 'Beta' : 'Inaktiv';
}

/**
 * Ob die Shell das Modul öffnen darf. Ein inaktives Modul nicht — außer für Tester mit einer
 * gültigen Modulvorschau (P11, `vorschauVon`): Sie müssen die neue Version vor der Freigabe
 * öffnen können.
 */
export function oeffenbar(status: unknown, mitVorschau: boolean): boolean {
  return modulStatus(status) !== 'inaktiv' || mitVorschau;
}
